import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';

import type IErrorModal from './interfaces/IErrorModal';

import styles from './scss/ErrorModal.module.scss';

function ErrorModal({
  open,
  onClose,
  errorMessage,
  className,
  title,
}: IErrorModal) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={title || ''}
      className={clsx(styles.modalContainer, className)}
      isButtonsVisible={false}
    >
      <div className={clsx(styles.root)}>
        <div className={styles.errorMessage}>
          <p>{errorMessage}</p>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.ok')}
            onClick={onClose}
            className={styles.button}
          />
        </div>
      </div>
    </Modal>
  );
}

export default ErrorModal;
